export enum OrgMembersViewTabs {
  Members = 'Members',
  Settings = 'Settings',
}

export enum SettingCategory {
  general = 'general_settings',
  contentManagement = 'content_management_setting',
  productSettings = 'product_settings',
  other = '',
}

export enum SettingCode {
  schoolLimit = 'school_limit',
  contentRepository = 'content_repository',
  alefAcademy = 'enable_alef_academy',
  pathway = 'enable_pathway',
}
